import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, PieChart, Pie, Cell, Legend } from "recharts";

const COLORS = ["#f59e0b", "#8b5cf6", "#10b981", "#ef4444", "#0ea5e9"];

export default function AdminReports() {
  const [stats, setStats] = useState(null);
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/submissions").then((r) => setSubs(r.data));
  }, []);

  const statusData = stats ? [
    { name: "Submitted", value: subs.filter(s => s.status === "Submitted").length },
    { name: "Under Review", value: subs.filter(s => s.status === "Under Review").length },
    { name: "Approved", value: stats.approved },
    { name: "Rejected", value: stats.rejected },
    { name: "Released", value: stats.released },
  ] : [];

  const byMonth = {};
  subs.forEach((s) => {
    const m = new Date(s.created_at).toLocaleString("en-US", { month: "short", year: "2-digit" });
    byMonth[m] = (byMonth[m] || 0) + 1;
  });
  const monthData = Object.entries(byMonth).map(([k, v]) => ({ month: k, count: v }));

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400">Administrator</div>
      <h1 className="mt-2 text-4xl font-bold tracking-tight">Reports</h1>

      <div className="mt-10 grid lg:grid-cols-2 gap-6">
        <div className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
          <h3 className="text-lg font-semibold mb-6">Submissions by Status</h3>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={statusData} dataKey="value" nameKey="name" outerRadius={100} innerRadius={60}>
                {statusData.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
              </Pie>
              <Tooltip contentStyle={{ background: "#18181b", border: "1px solid #27272a", borderRadius: 8 }} />
              <Legend wrapperStyle={{ color: "#a1a1aa" }} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="p-6 rounded-2xl border border-zinc-800 bg-zinc-950/60">
          <h3 className="text-lg font-semibold mb-6">Submissions by Month</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={monthData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#27272a" />
              <XAxis dataKey="month" stroke="#71717a" />
              <YAxis stroke="#71717a" />
              <Tooltip contentStyle={{ background: "#18181b", border: "1px solid #27272a", borderRadius: 8 }} />
              <Bar dataKey="count" fill="#22d3ee" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
